import React from "react";
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
/* Import Boostrap */
import { Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const FooterCopyright = ({ translate, props }) => {
  return (
    <Col md={12}>
      <p className="copyright">
        <span><small className="block">{translate(props.footerCopyright)}</small></span>
        <span><small className="block privacy"><Link to="/privacy">{translate(props.footerPrivacyPolicy)}</Link></small></span>
      </p>
    </Col>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(FooterCopyright);




// WEBPACK FOOTER //
// ./src/components/footer/footer-copyright.js